module.exports = __webpack_public_path__ + "images/orderdetails.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/orderdetails.png
// module id = dpff
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13